import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { TablePagination } from '@mui/material';
import BullLine from './BullLine';
import { MoulinetteLog } from '../../../models/moulinetteLog';
import { Bull } from '../../../models/bull';

export default function TableLine(props: { row: MoulinetteLog }) {
	const { row } = props;
	const { bulls } = row;
	const momentDate = moment(row.date);
	const formatedDate = momentDate.format('DD/MM/YYYY HH:mm:ss');
	const [open, setOpen] = useState(false);
	// Pagination
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [firstIndex, setfirstIndex] = useState(0);
	const [lastIndex, setLastIndex] = useState(rowsPerPage || 0);
	const [allDatas] = useState<Bull[] | null>(bulls);
	const currentItems: Bull[] = allDatas ? allDatas.slice(firstIndex, lastIndex) : [];

	const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
		if (allDatas) {
			const lastIndex = (newPage + 1) * rowsPerPage < allDatas.length ? (newPage + 1) * rowsPerPage : row.bulls.length;
			setLastIndex(lastIndex);
			setfirstIndex(newPage * rowsPerPage);
		}
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const rows = parseInt(event.target.value, 10);

		setLastIndex(rows);
		setRowsPerPage(rows);
		setfirstIndex(0);
		setCurrentPage(0);
	};

	const handleOpen = () => setOpen(true);

	const handleClose = () => setOpen(false);
	return (
		<TableRow sx={{ height: 45 }}>
			<TableCell>{formatedDate}</TableCell>
			<TableCell>{row.name}</TableCell>
			<TableCell>{row.bulls.length}</TableCell>
			<TableCell>
				{row.bulls.length > 0 && <Button onClick={handleOpen}>Ouvrir le log</Button>}

				<Modal
					open={open}
					onClose={handleClose}
					disablePortal
					disableEnforceFocus
					disableAutoFocus
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
					sx={{
						display: 'flex',
						p: 1,
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Box
						sx={{
							position: 'relative',
							width: 800,
							bgcolor: 'background.paper',
							boxShadow: (theme) => theme.shadows[5],
							p: 4,
						}}
					>
						<Box>
							<Typography id="modal-modal-title" variant="h6" component="h2">
								{row.name}
							</Typography>
							<Typography id="modal-modal-bulls" sx={{ mt: 2 }}>
								<Table size="small">
									<TableHead>
										<TableRow sx={{ textAlign: 'center' }}>
											<TableCell>NB. Taureau</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>{currentItems && currentItems.map((row: Bull, index: number) => <BullLine row={row} key={index} />)}</TableBody>
								</Table>
								{allDatas && <TablePagination component="div" count={allDatas.length} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage} />}
							</Typography>
						</Box>
					</Box>
				</Modal>
			</TableCell>
		</TableRow>
	);
}
